import { getTheme } from '@fluentui/react';

const { palette } = getTheme();

export const getLocationTargetingStyles = () => ({
  LocationTargeting: {
    '& .bing-maps-location-targets-editor': {
      marginLeft: 25,
    },
    // '& .bing-maps-location-targets-search-grid-and-map': {
    //   width: 950,
    // },
    '& .edit-action': {
      marginTop: 20,
    },
    '& .dropdown-menu > div > li > a:focus:after': {
      display: 'none',
    },
    '& .dropdown-menu > div > li > a:focus': {
      outline: `1px solid ${palette.neutralSecondary}`,
    },
    '& .bing-maps-search-box-dropdown': {
      maxWidth: 400,
    },

    '& .bing-maps-location-targets-search-box-with-search-options': {
      marginBottom: 0,
    },

    '& .bing-maps-location-targets-search-grid-and-map': {
      minWidth: 200,
      width: '100%',
      border: 'none',
      display: 'flex',
      flexDirection: 'column',
      marginLeft: -25,

      '& .bing-maps-location-targets-search-grid': {
        width: '100%',
        maxHeight: 'none',
      },

      '& .bing-maps-location-targets-editor-map': {
        width: '100%',
        height: 420,
        marginLeft: 0,
        '& .MicrosoftMap .bm_bottomRightOverlay .ScaleBar > div': {
          '& > div:nth-child(2) > div': {
            border: '10px solid #0056b3 !important',
          },
        },
      },

      '& .bing-maps-location-targets-grid': {
        minHeight: 0,
      },
      '& .bing-maps-negative-location-targets-grid': {
        minHeight: 0,
      },
    },

    '& .bing-maps-location-targets-empty': {
      color: '#a80000',
    },
  },
  locationTargetOptions: {
    marginBottom: 20,

    '& label': {
      fontWeight: 400,
      padding: 0,
    },

    '& div[role="radiogroup"] > label': {
      fontWeight: 600,
    },
  },
  intentTarget: {
    marginTop: 20,
  },
  intentTargetOptions: {
    marginTop: 6,
  },
  title: {
    '& span': {
      fontWeight: 600,
    },
  },
});
